module.exports = __webpack_public_path__ + "img/mvl_desktop.58aa1af7.png";